function fieldChangeRuleExecutor(template, ruleSetExecutor) {
    // dataSourceNode -> Promise[RuleSetResult]
    function runFieldChangeRulesAsync(node) {
        const dsName = node.getDsName();
        const domHandler = template.getRulesForField(dsName, node.getNode());
        const ruleSet = domHandler?.ruleSet;

        if (!ruleSet) {
            return null;
        }

        try {
            return ruleSetExecutor.runRuleSetAsync(ruleSet, node);
        } catch {
            console.error(err);
            alert('Some rules were not applied.');

            return null;
        }
    }

    return {
        runFieldChangeRulesAsync,
    };
}

export default fieldChangeRuleExecutor;